import React from 'react'
import { t } from '@lingui/core/macro'
import ErrorStatusIcon from '../../components/StatusIcon/ErrorStatusIcon'
import MainButton from '../../components/MainButton/MainButton'
import styles from './ErrorPage.module.css'

interface LoadDataErrorPageProps {
    title: string
    description: string
}

const LoadDataErrorPage = ({ title, description }: LoadDataErrorPageProps) => {
    return (
        <div className={styles.section}>
            <ErrorStatusIcon />

            <h1 className={styles.title}>{title}</h1>
            <p className={styles.description}>{description}</p>

            <MainButton
                message={t`Обновить страницу`}
                type="button"
                onClick={() => window.location.reload()}
                disabled={false}
            />
        </div>
    )
}

export default LoadDataErrorPage
